/* ============================================================
   PE × Hella — custom theme scripts
   One file for every pe-* section, loaded once (deferred) from
   layout/theme.liquid.

   All handlers are delegated from `document` rather than bound to
   elements, so sections re-rendered by the theme editor keep
   working without re-binding.
   ============================================================ */

/* ==========================================================
   1. FAQ — accordion + category tabs
   ========================================================== */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setHeight(panel, open) {
    if (window.gsap && !REDUCED) {
      gsap.to(panel, { height: open ? 'auto' : 0, duration: 0.24, ease: 'power2.out' });
    } else {
      panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
    }
  }

  function close(item) {
    item.classList.remove('is-open');
    var q = item.querySelector('.pe-faq__q');
    if (q) q.setAttribute('aria-expanded', 'false');
    var panel = item.querySelector('.pe-faq__a');
    if (panel) setHeight(panel, false);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.pe-faq__q');
    if (trigger) {
      var item = trigger.closest('.pe-faq__item');
      var list = trigger.closest('.pe-faq__list');
      var panel = item.querySelector('.pe-faq__a');
      var wasOpen = item.classList.contains('is-open');

      // one open item per list
      if (list) {
        list.querySelectorAll('.pe-faq__item.is-open').forEach(function (other) {
          if (other !== item) close(other);
        });
      }

      item.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      setHeight(panel, !wasOpen);
      return;
    }

    var tab = event.target.closest('.pe-faq__tab');
    if (!tab) return;

    var wrapper = tab.closest('.pe-faq');
    var list2 = wrapper && wrapper.querySelector('.pe-faq__list');
    if (!list2) return;

    var cat = tab.dataset.cat;
    wrapper.querySelectorAll('.pe-faq__tab').forEach(function (t) {
      t.setAttribute('aria-selected', String(t === tab));
    });

    list2.querySelectorAll('.pe-faq__item').forEach(function (item) {
      var show = cat === 'all' || item.dataset.cat === cat;
      item.hidden = !show;
      if (!show && item.classList.contains('is-open')) {
        item.classList.remove('is-open');
        var q = item.querySelector('.pe-faq__q');
        if (q) q.setAttribute('aria-expanded', 'false');
        var panel2 = item.querySelector('.pe-faq__a');
        if (window.gsap) gsap.set(panel2, { height: 0 });
        else panel2.style.height = '0px';
      }
    });

    if (window.gsap && window.ScrollTrigger) ScrollTrigger.refresh();
  });
})();

/* ==========================================================
   2. FOUNDER VIDEO — play button / embed swap
   ========================================================== */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pe-video-play]');
    if (!btn) return;

    var shell = btn.closest('.pe-video-shell');
    if (!shell) return;

    var html = shell.querySelector('[data-pe-video-embed]');
    if (html && html.innerHTML.trim()) {
      shell.innerHTML = html.innerHTML;
      var iframe = shell.querySelector('iframe');
      if (iframe && iframe.src.indexOf('autoplay') === -1) {
        iframe.src += (iframe.src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      }
      var video = shell.querySelector('video');
      if (video) video.play();
      return;
    }

    if (shell.querySelector('.pe-video-note')) return;
    var note = document.createElement('div');
    note.className = 'pe-video-note';
    note.textContent = 'Add the founder video in the theme editor to enable playback.';
    shell.appendChild(note);
  });
})();

/* ==========================================================
   3. ANIMATIONS — GSAP entrance + scroll reveals
   ========================================================== */
(function () {
  function init() {
    if (!window.gsap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    if (document.querySelector('.pe-hero')) {
      gsap.from('.pe-hero__logos', { opacity: 0, y: -8, duration: 0.45, ease: 'power2.out' });
      gsap.from('.pe-hero__copy > *:not(.pe-hero__logos)', {
        opacity: 0, y: 16, duration: 0.52, stagger: 0.06, ease: 'power2.out', delay: 0.08
      });
      gsap.from('.pe-hero__photo', { opacity: 0, x: 20, duration: 0.65, ease: 'power2.out', delay: 0.12 });
      gsap.from('.pe-hero__card', { opacity: 0, y: 18, rotate: -10, duration: 0.55, ease: 'power2.out', delay: 0.24 });
      gsap.from('.pe-hero__sticker', { opacity: 0, scale: 0.6, rotate: -24, duration: 0.55, ease: 'back.out(1.7)', delay: 0.32 });
      gsap.from('.pe-hero__ring', { opacity: 0, scale: 0.85, duration: 0.8, ease: 'power2.out', delay: 0.2 });
    }

    if (!window.ScrollTrigger) return;

    if (document.querySelector('.pe-video-section')) {
      gsap.from('.pe-video-head', {
        opacity: 0, y: 20, duration: 0.55, ease: 'power2.out',
        scrollTrigger: { trigger: '.pe-video-section', start: 'top 82%', once: true }
      });
      gsap.from('.pe-video-shell', {
        opacity: 0, y: 22, duration: 0.6, ease: 'power2.out', delay: 0.06,
        scrollTrigger: { trigger: '.pe-video-section', start: 'top 78%', once: true }
      });
    }

    gsap.utils.toArray('.pe-product-card').forEach(function (card, i) {
      gsap.from(card, {
        opacity: 0, y: 16, duration: 0.4, ease: 'power2.out', delay: (i % 4) * 0.035,
        scrollTrigger: { trigger: card, start: 'top 92%', once: true }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================
   4. GALLERY — product page image carousel
   ========================================================== */
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.peGalleryReady === 'true') return;
    gallery.dataset.peGalleryReady = 'true';

    var track = gallery.querySelector('.pe-gallery__track');
    var tiles = [].slice.call(gallery.querySelectorAll('.pe-gallery__tile'));
    var dots = [].slice.call(gallery.querySelectorAll('.pe-gallery__dot'));
    var prev = gallery.querySelector('.pe-gallery__nav--prev');
    var next = gallery.querySelector('.pe-gallery__nav--next');
    if (!track || tiles.length < 2) return;

    var index = 0;

    function sync() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === index)); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === tiles.length - 1;
    }

    function goTo(i) {
      index = Math.max(0, Math.min(tiles.length - 1, i));
      track.scrollTo({ left: tiles[index].offsetLeft, behavior: 'smooth' });
      sync();
    }

    // swipe on mobile scrolls the track directly — read the index back out of it
    function readIndex() {
      var best = 0, closest = Infinity;
      tiles.forEach(function (t, i) {
        var d = Math.abs(t.offsetLeft - track.scrollLeft);
        if (d < closest) { closest = d; best = i; }
      });
      if (best !== index) { index = best; sync(); }
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    track.addEventListener('scroll', readIndex, { passive: true });

    sync();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pe-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // theme editor re-renders a section's markup, which drops the listeners above
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
